import type { MatchedDatapoint } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

import { InstrumentTimeSeriesPreview } from './InstrumentTimeSeriesPreview'

interface InstrumentTimeSeriesTooltipProps {
  label: string
  matchedDatapoints: MatchedDatapoint[]
  linkedDocumentCount?: number
  clickHint?: string
}

const TOOLTIP_BG = '#0f0f0f'
const TOOLTIP_BORDER = '#2a2a2a'
const TOOLTIP_SHADOW = 'rgba(0, 0, 0, 0.4)'
const LABEL_COLOR = '#ffffff'

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 15rem;
  max-width: 20rem;
  background: ${TOOLTIP_BG};
  border-radius: 0.625rem;
  padding: 0.75rem;
  border: 1px solid ${TOOLTIP_BORDER};
  box-shadow: 0 0.5rem 2rem ${TOOLTIP_SHADOW};
`

const TooltipHeader = styled.div`
  display: flex;
  flex-direction: column;
`

const TooltipLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${LABEL_COLOR};
  letter-spacing: -0.01em;
`

export function InstrumentTimeSeriesTooltip({
  label,
  matchedDatapoints,
  linkedDocumentCount = 0,
  clickHint,
}: InstrumentTimeSeriesTooltipProps): React.JSX.Element {
  return (
    <TooltipContainer>
      <TooltipHeader>
        <TooltipLabel>{label}</TooltipLabel>
      </TooltipHeader>

      <InstrumentTimeSeriesPreview
        matchedDatapoints={matchedDatapoints}
        linkedDocumentCount={linkedDocumentCount}
        clickHint={clickHint}
      />
    </TooltipContainer>
  )
}
